/** True when getPartner API returns partner_tier as "Not Eligible" (case-insensitive). */
export function isPartnerTierNotEligible(
  partnerTier?: string | null
): boolean {
  if (partnerTier == null || partnerTier === "") {
    return false;
  }
  return partnerTier.trim().toLowerCase() === "not eligible";
}
